module.exports = __webpack_public_path__ + "static/media/crop_howto.a4e16406.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/crop_howto.png
// module id = 482
// module chunks = 2